export default "__VITE_ASSET__Cbl1T9G6__"